import { message } from 'antd';
import React, { useEffect, useState } from 'react'

const useSpeech = () => {
    const [voicesLoaded, setVoicesLoaded] = useState(false);
    const [voiceList, setVoiceList] = useState([]);

    // Load voices safely
    useEffect(() => {
        const loadVoices = () => {
            const voices = window.speechSynthesis.getVoices();
            if (voices.length > 0) {
                setVoiceList(voices);
                setVoicesLoaded(true);
            }
        };

        loadVoices();
        window.speechSynthesis.onvoiceschanged = loadVoices;
    }, []);
    const playAudio = (lang,text) => {
        if (!voicesLoaded) {
            console.warn("Voices not loaded yet");
            return;
        }

        const synth = window.speechSynthesis;
        synth.cancel();

        const message = text;

        const utterance = new SpeechSynthesisUtterance(message);
        utterance.lang = lang == "hi" ? "hi-IN" : "en-US";

        // Try to assign a matching voice
        const matchedVoice = voiceList.find((v) => v.lang === utterance.lang);
        if (matchedVoice) {
            utterance.voice = matchedVoice;
        } else {
            console.warn("Matching voice not found, using default voice");
        }

        synth.speak(utterance);
    };
    return { playAudio }
}

export default useSpeech